import { Building2, Map, Target, History } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { RetailerDestination } from '../../lib/retailerViewUtils';

interface RetailerNavProps {
  active: RetailerDestination;
  onChange: (destination: RetailerDestination) => void;
}

const NAV_ITEMS: Array<{ id: RetailerDestination; label: string; icon: typeof Map }> = [
  { id: 'details', label: 'Details', icon: Building2 },
  { id: 'map', label: 'Floorplan', icon: Map },
  { id: 'campaigns', label: 'Campaigns', icon: Target },
  { id: 'history', label: 'History', icon: History },
];

export function RetailerNav({ active, onChange }: RetailerNavProps) {
  return (
    <nav
      aria-label="Store navigation"
      className="flex gap-0.5 overflow-x-auto border-b pb-0 sm:gap-1"
    >
      {NAV_ITEMS.map(({ id, label, icon: Icon }) => {
        const isActive = active === id;
        return (
          <Button
            key={id}
            type="button"
            variant="ghost"
            onClick={() => onChange(id)}
            className={`h-10 shrink-0 rounded-none border-b-2 px-2 text-xs sm:px-3 sm:text-sm ${
              isActive
                ? 'border-blue-600 text-blue-900 bg-transparent hover:bg-blue-50/50'
                : 'border-transparent text-gray-600 hover:text-gray-900'
            }`}
            aria-current={isActive ? 'page' : undefined}
          >
            <Icon className="mr-1 h-4 w-4 shrink-0 sm:mr-1.5" aria-hidden />
            {label}
          </Button>
        );
      })}
    </nav>
  );
}
